module.exports = __webpack_public_path__ + "img/PaymentHistory.f5472041.png";